<template>
    <span class="kb-time" :title="absolute">{{ relative }}</span>
</template>

<script>
import moment from 'moment';

export default {
    name: 'kb-time',

    props: {
        value: {
            type: String,
            default: null,
        },
    },

    computed: {
        relative() {
            if(!this.value) return '';
            return moment(this.value).fromNow();
        },
        absolute() {
            if(!this.value) return '';
            return moment(this.value).format('YYYY-MM-DD HH:mm');
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/knowledge-base/kb-time.vue